import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { Eye, Phone, Info, CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PlanYourVisitCTA } from '../components/PlanYourVisitCTA';
import { PHONE, PHONE_TEL } from '../constants/business';
export function ThermalOptics() {
  useDocumentMeta('Thermal Optics | Pulsar, Vortex & Hunting Optics | Kjergaard Sports', 'Thermal optics, Pulsar, Vortex, and hunting optics at Kjergaard Sports in Lake Benton, Minnesota — a top Pulsar dealer in the country.');
  return <div data-id="element-1253">
      <PageHero title="Thermal Optics" image="https://cdn.magicpatterns.com/uploads/1zvBEqUZKRM4BZCWhxgmNi/optics-cases.jpg" alt="In-store optics cases at Kjergaard Sports including thermal optics" data-id="element-1254" />

      <section className="py-20 bg-brand-offwhite" data-id="element-1255">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1256">
          <div className="max-w-3xl mb-16" data-id="element-1257">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-1258">
              Thermal Optics for Serious Hunters
            </h2>
            <p className="text-lg text-brand-charcoal/80 leading-relaxed" data-id="element-1259">
              Thermal optics has become a major focus at Kjergaard Sports.
              Whether you're after coyotes, hogs, or other predators where
              lawful, our team can help you compare options in person and pick
              the right setup for your hunt.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-1260">
            <div data-id="element-1261">
              <div className="flex items-center space-x-3 mb-4" data-id="element-1262">
                <div className="h-px w-8 bg-brand-leather" data-id="element-1263"></div>
                <span className="text-brand-hunter uppercase tracking-widest text-xs font-semibold" data-id="element-1264">
                  Top-3 Pulsar Dealer in the Country Last Year
                </span>
              </div>
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-1265">
                Pulsar Thermal Optics
              </h2>
              <p className="text-lg text-brand-charcoal/80 leading-relaxed" data-id="element-1266">
                Kjergaard Sports was Pulsar's #3 store in the country last year,
                giving our customers access to deep product knowledge and
                real-world guidance. We carry a strong Pulsar lineup and can
                help you compare models in person.
              </p>
            </div>
            <div data-id="element-1267">
              <img src="https://cdn.magicpatterns.com/uploads/1zvBEqUZKRM4BZCWhxgmNi/optics-cases.jpg" alt="Pulsar thermal optics in cases at Kjergaard Sports" className="w-full h-auto rounded-sm shadow-lg object-cover" data-id="element-1268" />
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-1269">
            <div className="order-2 lg:order-1" data-id="element-1270">
              <img src="https://cdn.magicpatterns.com/uploads/kENmASH4b2qj4AE9LqDfT7/mounted-rural-detail.jpg" alt="Hunting optics and outdoor scene at Kjergaard Sports" className="w-full h-auto rounded-sm shadow-lg object-cover" data-id="element-1271" />
            </div>
            <div className="order-1 lg:order-2" data-id="element-1272">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-1273">
                Vortex & Other Hunting Optics
              </h2>
              <p className="text-lg text-brand-charcoal/80 leading-relaxed" data-id="element-1274">
                We also carry Vortex and other trusted optics brands. Whether
                you're mounting glass on a hunting rifle or building a precision
                rig, we can help you compare clarity, reticles, and price points
                side by side.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-brand-cream" data-id="element-1275">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1276">
          <Eye className="w-12 h-12 text-brand-hunter mx-auto mb-6" data-id="element-1277" />
          <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-1278">
            Why In-Person Comparison Matters
          </h2>
          <p className="text-lg text-brand-charcoal/80 leading-relaxed" data-id="element-1279">
            Thermal optics is one of the hardest categories to buy online. Image
            clarity, detection range, refresh rate, and user interface vary
            widely between models. Stopping in to look through the units before
            you commit will save you time and money.
          </p>
        </div>
      </section>

      <section className="py-20 bg-brand-bone" data-id="element-1280">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1281">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-8 text-center" data-id="element-1282">
            Questions to Ask Before Choosing Thermal
          </h2>
          <div className="bg-brand-offwhite p-8 rounded-sm border border-brand-cream" data-id="element-1283">
            <ul className="space-y-4" data-id="element-1284">
              {['What are you hunting and at what distance?', 'Are you looking for a scope, monocular, or handheld unit?', "What's your budget range?", 'Do you already own a host firearm, or are you outfitting from scratch?', 'Will you need a recording or streaming feature?'].map((q, i) => <li key={i} className="flex items-start" data-id="element-1285">
                  <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-3 flex-shrink-0 mt-0.5" data-id="element-1286" />
                  <span className="text-brand-charcoal/90 leading-relaxed" data-id="element-1287">
                    {q}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      <section className="py-16 bg-brand-offwhite" data-id="element-1288">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1289">
          <h3 className="text-2xl font-serif text-brand-charcoal mb-4" data-id="element-1290">
            Future Buying Guides & Blog Topics
          </h3>
          <p className="text-brand-charcoal/75 leading-relaxed" data-id="element-1291">
            We're planning to add deeper Pulsar buying guides and thermal optics
            blog posts. Until then, the best resource is a phone call or an
            in-store visit.
          </p>
        </div>
      </section>

      <section className="py-20 bg-brand-cream" data-id="element-1292">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1293">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-1294">
            Call About Thermal Optics
          </h2>
          <p className="text-lg text-brand-charcoal/80 mb-10 leading-relaxed" data-id="element-1295">
            Have a specific Pulsar or thermal optics question? Give us a call
            and we'll talk through what's a fit for your hunt and budget.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-8" data-id="element-1296">
            <a href={PHONE_TEL} className="bg-brand-hunter hover:bg-brand-wood text-brand-offwhite px-7 py-3.5 rounded-sm font-medium transition-colors inline-flex items-center justify-center" data-id="element-1297">
              <Phone className="w-5 h-5 mr-2" data-id="element-1298" />
              Call {PHONE}
            </a>
            <Link to="/contact" className="border-2 border-brand-hunter text-brand-hunter hover:bg-brand-hunter hover:text-brand-offwhite px-7 py-3.5 rounded-sm font-medium transition-colors inline-flex items-center justify-center" data-id="element-1299">
              Visit the Store
            </Link>
            <Link to="/contact" className="border border-brand-charcoal/20 hover:border-brand-leather text-brand-charcoal px-7 py-3.5 rounded-sm font-medium transition-colors inline-flex items-center justify-center" data-id="element-1300">
              Ask a Question
            </Link>
          </div>

          <div className="bg-brand-offwhite border-l-4 border-brand-leather p-6 text-left max-w-2xl mx-auto" data-id="element-1301">
            <div className="flex items-start" data-id="element-1302">
              <Info className="w-5 h-5 text-brand-leather mr-3 flex-shrink-0 mt-0.5" data-id="element-1303" />
              <p className="text-brand-charcoal/85 text-sm leading-relaxed" data-id="element-1304">
                Information on this page is general information only and is not
                legal advice. Hunting regulations vary by state and species —
                please consult applicable laws.
              </p>
            </div>
          </div>
        </div>
      </section>

      <PlanYourVisitCTA data-id="element-1305" />
    </div>;
}